import React, {useState} from 'react';
import {Button, Card, CardContent, Grid, Typography, } from '@mui/material';
import styles from 'styles/informacionDelCard';
import TituloConIcono from 'components/tituloConIcono';
import ElementoDelCard from 'components/card/ElementoDelCard';
import Card64Image from 'components/card64Image';
import DialogoPantallaCompleta from 'components/Dialogo/DialogoPantallaCompleta';
import { TablaPersonalizada } from 'components';
import { functions } from 'constantes';
import ModalDeConfirmacion from 'components/Modales/ModalDeConfirmacion';
import TooltipPersonalizado from 'components/tooltip/TooltipPersonalizado';
import { useDispatch } from 'react-redux';
import { patchPersonalizadoConDosMetodos } from 'store/actions/customAction';
import { Edit } from '@mui/icons-material';
import EditarDatosDeLaPantalla from './EditarDatosDeLaPantalla';
import IndicadorDeCarga from 'components/IndicadorDeCarga';
import AlertaDeRespuesta from 'components/AlertaDeRespuesta';
import AgregarDisponibilidad from 'components/nuevoTarifario/detalleDelTarifario/AgregarDisponibilidad';
import EditarValorDeLaTarifa from 'components/nuevoTarifario/detalleDelTarifario/EditarValorDeLaTarifa';

let idDisponibilidad = null;

const DetalleDeLaPantallaDigital = ({title, openFullScreenDialog, handleClose, datosGeneralesDelTarifario, mostrarDetalleDelMedio, tipoDelMedio}) => {
  const classes = styles();
  const dispatch = useDispatch();

  const {medioDeComunicacion: {tarifario, disponibilidad}, departamento, municipio, alto, ancho, coordenadas, sentidoDeVisualizacion, descripcionUbicacion, imagenDePantalla} = datosGeneralesDelTarifario;

  const [abrirModalAgregarDisponibilidad, setAbrirModalAgregarDisponibilidad ] = useState(false),
  [alertaDeConfirmacion, setAlertaDeConfirmacion] = useState(false),
  [datosDisponibilidad, setDatosDisponibilidad] = useState(""),
  [datosDeRespuesta, setDatosDeRespuesta] = useState({ tipoDeAlerta: 'error', mensajeDeAlerta: '', mostrarRespuesta: false, }),
  [cargandoSolicitud, setCargandoSolicitud] = useState(false),
  [editarTarifario, setEditarTarifario] = useState(false),
  [datosTarifario, setDatosTarifario] = useState(""),
  [abrirModalEdicion, setAbrirModalEdicion] = useState(false);

  const [encabezadoDisponibilidad] = useState([
    { title: 'Fecha de Inicio', field: 'fechaInicio', render: (rowData) => functions.FormatearFecha(rowData.fechaInicio || "")},
    { title: 'Fecha Fin', field: 'fechaFin', render: (rowData) => functions.FormatearFecha(rowData.fechaFin || "")},
    { title: 'Acción', field: 'accion',
    render: rowData=><div style={{minWidth: '100px'}}>
        {
            (<div>
                <TooltipPersonalizado title="Eliminar disponibilidad" handleFunction={() => eliminarDisponibilidad(rowData)} icon="delete" fontSize={30} color="red" />
            </div>)
        }
        </div>
    },
  ]);

  const [encabezadoTarifario] = useState([
    { title: 'Mes', field: 'mes.descripcion'},
    { title: 'Valor', field: 'valorDeTarifa'},
    { title: 'Acción', field: 'accion',
    render: rowData=><div style={{minWidth: '100px'}}>
        {
            (<div>
                <TooltipPersonalizado title="Editar valor de tarifa" handleFunction={() => editarValorTarifario(rowData)} icon="edit" fontSize={30} color="primary" />
            </div>)
        }
        </div>
    },
  ]);

  const eliminarDisponibilidad = ({fechaInicio, fechaFin, id}) => {
    idDisponibilidad = id;
    setAlertaDeConfirmacion(true)
    setDatosDisponibilidad(`${functions.FormatearFecha(fechaInicio || "")} A ${functions.FormatearFecha(fechaFin || "")}`)
  }

  const cerrarAlertaDeConfirmacion = () => setAlertaDeConfirmacion(false);

  const accionDeAlertaDeConfirmacion = async () => {
    setAlertaDeConfirmacion(false);
    setCargandoSolicitud(true);
    changeDataResponse('error', "")

    const data = { controller: "tarifarioDePantallasDigitales", action: 'eliminar', data: {}, method: "disponibilidad", methodTwo: `${datosGeneralesDelTarifario?.medioDeComunicacion?.id}/${idDisponibilidad}`, tipoMetodo: "DELETE" };
    const respuesta = await dispatch(patchPersonalizadoConDosMetodos(data));
    setCargandoSolicitud(false);
    if(respuesta?.error) return setDatosDeRespuesta({ tipoDeAlerta: 'error', mensajeDeAlerta: respuesta?.error?.message || "", mostrarRespuesta: true, });
    setDatosDeRespuesta({ tipoDeAlerta: 'success', mensajeDeAlerta: respuesta?.data || "Registro eliminado correctamente", mostrarRespuesta: true, });
    const elemento = {medioDeComunicacion: {id: datosGeneralesDelTarifario.medioDeComunicacion?.id }}
    mostrarDetalleDelMedio(elemento)
  }

  // eliminar la tarifario
  const editarValorTarifario = ({mes, valorDeTarifa}) => {
    setEditarTarifario(true)
    setDatosTarifario({id: mes.id, mes: mes.descripcion, valorDeTarifa})
  }
  const cerrarEditarTarifario = () => setEditarTarifario(false);

  const accionTarifaEditada = (respuesta) => {
    setEditarTarifario(false);
    setDatosDeRespuesta({ tipoDeAlerta: 'success', mensajeDeAlerta: respuesta || "Registro eliminado correctamente", mostrarRespuesta: true, });
    const elemento = {medioDeComunicacion: {id: datosGeneralesDelTarifario.medioDeComunicacion?.id }}
    mostrarDetalleDelMedio(elemento)
  }

  const agregarDisponibilidad = () => setAbrirModalAgregarDisponibilidad(true);
  const cerraModalDisponibilidad = () => setAbrirModalAgregarDisponibilidad(false);

  const accionRegistroGuardado = (respuesta) => {
    setAbrirModalAgregarDisponibilidad(false);
    setDatosDeRespuesta({ tipoDeAlerta: 'success', mensajeDeAlerta: respuesta || "Registro eliminado correctamente", mostrarRespuesta: true, });
    const elemento = {medioDeComunicacion: {id: datosGeneralesDelTarifario.medioDeComunicacion?.id }}
    mostrarDetalleDelMedio(elemento)
  }

  const cerrarModalPorError = (respuesta) => {
    cerraModalDisponibilidad();
    setDatosDeRespuesta('error', `${respuesta?.error}` || "Ocurrió un inconveniente. Intente de nuevo!", true)
  }

  const mostrarModalEdicion = () => setAbrirModalEdicion(true);

  const cerrarEdicion = () => setAbrirModalEdicion(false);

  const accionRegistroEditado = (respuesta) => {
    setAbrirModalEdicion(false);
    setDatosDeRespuesta({ tipoDeAlerta: 'success', mensajeDeAlerta: respuesta?.data || "Registro editado correctamente", mostrarRespuesta: true, });
    const elemento = {medioDeComunicacion: {id: datosGeneralesDelTarifario.medioDeComunicacion?.id }}
    mostrarDetalleDelMedio(elemento)
  }

  const validarTipoDeTarifario = () => "tarifarioDePantallasDigitales";

  const handClose = (_, reason) => {
    if (reason === 'clickaway') {return}
    changeDataResponse('error', '', false)
  };

  const changeDataResponse = (tipoDeAlerta, mensajeDeAlerta, mostrarRespuesta = false) =>  setDatosDeRespuesta({tipoDeAlerta, mensajeDeAlerta, mostrarRespuesta});
  const {tipoDeAlerta, mensajeDeAlerta, mostrarRespuesta} = datosDeRespuesta;


  const closeFullScreenForm = function() { handleClose() }

  return (
    <DialogoPantallaCompleta
      openFullScreenDialog={openFullScreenDialog}
      handleClose={closeFullScreenForm}
      title={title}
      fullscreen={true}
      showButtonClose={false}
      showIconButton={true}
    >
    <Card className={classes.root}>
        <CardContent>
            {cargandoSolicitud ? <IndicadorDeCarga open={cargandoSolicitud} /> : '' }
            <AlertaDeRespuesta type={tipoDeAlerta} content={mensajeDeAlerta} open={mostrarRespuesta} handClose={handClose}/>

            <Grid container justify="space-between" alignItems="center" spacing={4} wrap={"wrap"} >
              <Grid item xs={12}>
                <TituloConIcono title={"Datos de la pantalla digital"} mostrarTiempo={false} mostrarBotones={false} showIcon={false} />
              </Grid>
              <Grid item xs={12} md={6}>
                <ElementoDelCard title={'Departamento:'} label={departamento?.nombre || ""}/>
                <ElementoDelCard title={'Municipio:'} label={municipio?.nombre || ""}/>
                <ElementoDelCard title={'Ancho:'} label={ancho || ""}/>
                <ElementoDelCard title={'Alto:'} label={ alto || ""}/>
                <ElementoDelCard title={'Coordenadas:'} label={coordenadas || ""}/>
                <ElementoDelCard title={'Sentido de visualización:'} label={sentidoDeVisualizacion?.descripcion || ""}/>
                <ElementoDelCard title={'ubicación de la pantalla:'} label={descripcionUbicacion || ""}/>
              </Grid>
              <Grid item xs={12} md={6}>
                <br/>
                {imagenDePantalla ? (
                      <Card64Image
                          label={"LOGO"} image={imagenDePantalla} title={"LOGO"} src={imagenDePantalla} showTitle={false} showTitle2={true} documentName={imagenDePantalla} getDocumentOfPoliticalOrganization={undefined} showButtonEditDocument={false} handleClickUpdateDocument={undefined}
                          showInMovil={true} firstTitle={""} observacion={""} idDocumento={"idDocumento"} idEstadoDocumento={""}
                      />
                ): <Typography variant="h5" component="div" align='center'> No Adjunto imagen de la pantalla digital</Typography>}
                <Grid container justifyContent={"center"} alignItems="center" mt={5}>
                  <Button variant="contained" color="primary" onClick={mostrarModalEdicion} size="large">
                    <Edit />
                    Editar datos de la pantalla digital
                  </Button>
                </Grid>
              </Grid>
            </Grid>
            <Grid container justify="space-between" alignItems="center" spacing={4} wrap={"wrap"} >
              <Grid item xs={12} md={6}>
                <TituloConIcono title={"Tarifario"} mostrarTiempo={false} mostrarBotones={false} showIcon={false} />
                <TablaPersonalizada
                    pageSize={10}
                    data={tarifario?.length > 0 ? functions.ordenarArreglo(tarifario, "mes_id") : [] }
                    title={"Listado de tarifario"}
                    header={encabezadoTarifario}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                  <TituloConIcono title={"Disponibilidad"} mostrarTiempo={false} mostrarBotones={false} showIcon={false} />
                  <TablaPersonalizada
                      pageSize={10}
                      data={disponibilidad?.length > 0 ? functions.ordenarArreglo(disponibilidad, "fechaInicio") : [] }
                      title={"Listado de disponibilidades"}
                      header={encabezadoDisponibilidad}
                      addRegister={agregarDisponibilidad}
                      nameToolTipAdd={"Agregar disponibilidad"}
                  />
              </Grid>
          </Grid>
          {abrirModalEdicion && (
            <EditarDatosDeLaPantalla
                openFullScreenDialog={abrirModalEdicion}
                handleClose={cerrarEdicion}
                title={`Formulario para editar datos de la pantalla digital`}
                datossDelTarifario={datosGeneralesDelTarifario}
                accionRegistroEditado={accionRegistroEditado}
            />
          )}
          {abrirModalAgregarDisponibilidad && (
            <AgregarDisponibilidad
                openFullScreenDialog={abrirModalAgregarDisponibilidad}
                handleClose={cerraModalDisponibilidad}
                title={`Formulario para agregar disponibilidad `}
                medioDeComunicacion={{...datosGeneralesDelTarifario.medioDeComunicacion, canalDeTercero: 1, tipoDelMedio}}
                validarTipoDeTarifario={validarTipoDeTarifario}
                accionRegistroGuardado={accionRegistroGuardado}
                cerrarModalPorError={cerrarModalPorError}
            />
          )}
          {alertaDeConfirmacion && (
            <ModalDeConfirmacion
                title={`¿Está seguro de eliminar el rango de ${datosDisponibilidad || ""}?`} message={"No podrá revertir esta acción"}
                open={alertaDeConfirmacion} closeModal={cerrarAlertaDeConfirmacion} titleButton={"Sí, estoy seguro"}
                actionAdd={accionDeAlertaDeConfirmacion}
            />
          )}
          {editarTarifario && (
            <EditarValorDeLaTarifa
                openFullScreenDialog={editarTarifario}
                handleClose={cerrarEditarTarifario}
                title={`Formulario para editar valor de la tarifa `}
                medioDeComunicacion={{...datosGeneralesDelTarifario.medioDeComunicacion,}}
                datosTarifario={datosTarifario}
                validarTipoDeTarifario={validarTipoDeTarifario}
                accionTarifaEditada={accionTarifaEditada}
            />
          )}
        </CardContent>
    </Card>
    </DialogoPantallaCompleta>
  );
}

export default DetalleDeLaPantallaDigital;